import { IconNames } from "@repo/core/components/core/Icon/types";
import { ModalTemplateProps } from "../types";

export interface AlertModalProps extends ModalTemplateProps {
  variant?: AlertModalVariant;
  icon?: IconNames;
  maxWidth?: number;
  title?: string;
  iconColor?: string;
  iconVariant?: "regular" | "solid";
  isLoading?: boolean;
  showIcon?: boolean;
}

export enum AlertModalVariant {
  "success" = "success",
  "error" = "error",
  "warning" = "warning"
}
